import { MetricTypes } from 'common/constants/metric-types';
import { AdvancedReportTableRow } from '../advanced-reports-table.types';

export const sortRows = (
  rows: AdvancedReportTableRow[],
  idToSort: string,
  isDesc: boolean
): AdvancedReportTableRow[] => {
  switch (idToSort) {
    case MetricTypes.IMPRESSIONS:
      return isDesc
        ? sortDesc(rows, (row) => row.impressions.primaryValue)
        : sortAsc(rows, (row) => row.impressions.primaryValue);
    case MetricTypes.CLICKS:
      return isDesc
        ? sortDesc(rows, (row) => row.clicks.primaryValue)
        : sortAsc(rows, (row) => row.clicks.primaryValue);
    case MetricTypes.INBOUND_CALL:
      return isDesc
        ? sortDesc(rows, (row) => row.call.primaryValue)
        : sortAsc(rows, (row) => row.call.primaryValue);
    case MetricTypes.WEB:
      return isDesc
        ? sortDesc(rows, (row) => row.web.primaryValue)
        : sortAsc(rows, (row) => row.web.primaryValue);
    case MetricTypes.OPPORTUNITIES:
      return isDesc
        ? sortDesc(rows, (row) => row.opportunity.primaryValue)
        : sortAsc(rows, (row) => row.opportunity.primaryValue);
    case MetricTypes.OPPORTUNITY_VALUES:
      return isDesc
        ? sortDesc(rows, (row) => row.opportunityValue.primaryValue)
        : sortAsc(rows, (row) => row.opportunityValue.primaryValue);
    case MetricTypes.REVENUES:
      return isDesc
        ? sortDesc(rows, (row) => row.sales.primaryValue)
        : sortAsc(rows, (row) => row.sales.primaryValue);
    case MetricTypes.REVENUE_VALUES:
      return isDesc
        ? sortDesc(rows, (row) => row.revenue.primaryValue)
        : sortAsc(rows, (row) => row.revenue.primaryValue);
    case MetricTypes.COST:
      return isDesc
        ? sortDesc(rows, (row) => row.cost.primaryValue)
        : sortAsc(rows, (row) => row.cost.primaryValue);
    case MetricTypes.CPA:
      return isDesc
        ? sortDesc(rows, (row) => row.cpa.primaryValue)
        : sortAsc(rows, (row) => row.cpa.primaryValue);
    case MetricTypes.CPS:
      return isDesc
        ? sortDesc(rows, (row) => row.cps.primaryValue)
        : sortAsc(rows, (row) => row.cps.primaryValue);
    case MetricTypes.ROI:
      return isDesc
        ? sortDesc(rows, (row) => row.roi.primaryValue)
        : sortAsc(rows, (row) => row.roi.primaryValue);
    case MetricTypes.ROAS:
      return isDesc
        ? sortDesc(rows, (row) => row.roas.primaryValue)
        : sortAsc(rows, (row) => row.roas.primaryValue);
    default:
      return sortAsc(rows, (row) => row.id);
  }
};

function sortAsc(
  rows: AdvancedReportTableRow[],
  predicate: (report: AdvancedReportTableRow) => number | string
): AdvancedReportTableRow[] {
  return rows.sort((a, b) => (predicate(a) > predicate(b) ? 1 : -1));
}

function sortDesc(
  rows: AdvancedReportTableRow[],
  predicate: (report: AdvancedReportTableRow) => number | string
): AdvancedReportTableRow[] {
  return rows.sort((a, b) => (predicate(a) > predicate(b) ? -1 : 1));
}
